import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import classnames from 'classnames';

import { Button, Currency, Icon, InputContainer, Link, NoResults, PageTitle } from '../../components';
import BackToTop from '~COMPONENTS/BackToTop';
import SortOptions from '~COMPONENTS/sortOptions/SortOptions';
import LoadingMessage from '~COMPONENTS/spinner/LoadingMessage';
import FilterTag from '~COMPONENTS/filters/FilterTag';
import GlobalToolTip from '~COMPONENTS/tooltips/GlobalToolTip';
import PageHeader from '~COMPONENTS/containers/PageHeader';
import TextInput from '~COMPONENTS/formInputs/TextInput';
import GridwallProducts from './GridwallProducts';
import GridwallFilters from './GridwallFilters';
import QuickAdd from './QuickAdd';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { findStyleForProduct } from '../util/helpers';

import ProductGenderDivision from '~COMPONENTS/pdp/ProductGenderDivision';
import GridwallSearchToolTip from '~COMPONENTS/tooltips/GridwallSearchToolTip';

import {
  addPriceRange,
  clearProducts,
  clearSelectedFacet,
  clearSelectedFilters,
  clearSelectedFiltersMinusCatalogs,
  removeSelectedFilter,
  requestProducts,
  resetCursor,
  selectProduct,
  setAllSizesAvailable,
  setIncludeUnavailableProduct,
  setSearchTerm,
  togglePriceRangeSet
} from '../actions';
import {
  DEPT_SELECT_URL,
  GRIDWALL_MAX_PRICE,
  GRIDWALL_MIN_PRICE,
  GRIDWALL_PRODUCT_LOAD_QTY,
  GRIDWALL_PRODUCT_SEARCH_LOAD_QTY,
  PRODUCT_SEARCH_MAX,
  ORDER_TYPE_ATONCE,
  regionToLanguageMap,
  productDivisionMap
} from '../constants';
import {
  filterCount,
  getActiveSubTypeFacets,
  getAllSubTypeFacets,
  getCursorValue,
  getFacets,
  getFilters,
  getIsFetching,
  getProductCount,
  getShopProducts,
  getSelectedDepartment,
  getSelectedFacets,
  getSelectedFilters,
  priceRangeMax,
  priceRangeMin,
  priceRangeSet,
  searchTerm,
  selectAllSizesAvailable,
  selectIncludeUnavailableProduct
} from '../selectors';
import { setSortBy, setScrollCache } from '../../global/actions';
import { sortBy, getScrollCache } from '../../global/reducer';
import { accountDetails, getUserAccount, getUserData } from '../../user/selectors';

import { selectedDepartmentTypes } from '../../types/shop';
import { productTypes } from '../../types/products';
import { userAccountTypes, userTypes } from '../../types/user';
import { formatSearchInput, containsProductCode, containsStyleNumber, isColorCode } from '~APP_UTIL/formValidations';

import { hasAllotmentsOrOptions } from '../../util/allotmentsAndOptions';
import { sortByTypes } from '../../types/status';
import { getDefaultSizeConversion } from '../../util/countryFootwearSizing';

import { getAllotmentsForSelectedDepartment, getIsGreaterChinaSalesOrg } from '../../gamedayAccount/selectors';

import { sendEventToGA, GA_EVENT_SEARCH_TERM } from '../../analytics/constants';

const PAGE = 'GRIDWALL';

export class Gridwall extends Component {
  constructor(props) {
    super(props);
    const { products, after } = this.props;
    this.state = {
      defaultPrice: [GRIDWALL_MIN_PRICE, GRIDWALL_MAX_PRICE],
      // Default to true if products aren't loaded yet
      // OR if an after string is provided
      hasMore: products.length === 0 || typeof after === 'string',
      isFilterOpen: false,
      searchInput: '',
      showSearch: false,
      sortedProducts: [],
      searchError: false,
      wholesalePrice: [GRIDWALL_MIN_PRICE, GRIDWALL_MAX_PRICE],
      newFilter: false,
      requestQueue: 0,
      deptFacets: null,
      isProductSearch: false,
      scrollCache: 0,
      savedSearchKey: ''
    };
  }

  componentDidMount() {
    const {
      accountDetails,
      facets,
      products,
      selectedDepartment,
      searchTerm,
      user,
      unitAllotments = [],
      includeUnavailableProduct,
      setIncludeUnavailableProduct
    } = this.props;
    const currSearchTerm = Object.values(searchTerm)[0];

    if (includeUnavailableProduct && selectedDepartment?.type !== ORDER_TYPE_ATONCE) {
      setIncludeUnavailableProduct(false);
    }

    if (accountDetails && selectedDepartment && user && !products.length) {
      this.fetchProducts(true);
    }

    if (products && products.length > 0) {
      const { products } = this.props;
      const productsWithOptions = products.map(style => ({
        ...style,
        products: style.products.map(prod => ({
          ...prod,
          hasPurchaseOptions: hasAllotmentsOrOptions(selectedDepartment.purchaseOptions, prod),
          hasUnitAllotments: hasAllotmentsOrOptions(unitAllotments, prod)
        }))
      }));
      this.setProductList(productsWithOptions, this.setPreviousScrollLocation);
    }

    if (currSearchTerm) {
      this.setSearchInput(currSearchTerm);
    }

    this.setDeptFacets(products.length ? facets : null);

    // Set on-scroll listener
    window.onscroll = this.scrollChange;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { scrollCache } = this.state;
    const { scrollCache: nextScrollCache } = nextState;
    return nextScrollCache === scrollCache;
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      accountDetails,
      clearSelectedFilters,
      clearSelectedFiltersMinusCatalogs,
      priceRangeMax,
      priceRangeMin,
      priceRangeSet,
      searchTerm: { productName, styleNumbers, productCode },
      selectedDepartment,
      selectedFacets,
      selectedFilters
    } = this.props;
    const { requestQueue } = this.state;
    const { requestQueue: prevRequestQueue } = prevState;
    const {
      accountDetails: prevAccountDetails,
      searchTerm: { productName: prevProductName, styleNumbers: prevStyleNumbers, productCode: prevProductCode },
      selectedFilters: prevSelectedFilters,
      selectedFacets: prevSelectedFacets,
      priceRangeMax: prevPriceRangeMax,
      priceRangeMin: prevPriceRangeMin,
      priceRangeSet: prevPriceRangeSet
    } = prevProps;

    if (accountDetails !== prevAccountDetails) {
      this.loadFilteredProducts();
      return;
    }

    if (selectedFacets !== prevSelectedFacets) {
      if (selectedFilters.catalogs) {
        clearSelectedFiltersMinusCatalogs();
      } else {
        clearSelectedFilters();
      }
      this.loadFilteredProducts();
    } else if (
      selectedDepartment &&
      selectedDepartment.departmentNumber &&
      (accountDetails !== prevAccountDetails ||
        productName !== prevProductName ||
        styleNumbers !== prevStyleNumbers ||
        productCode !== prevProductCode ||
        selectedFilters !== prevSelectedFilters ||
        ((priceRangeSet || (prevPriceRangeSet && !priceRangeSet)) &&
          (prevPriceRangeMax !== priceRangeMax || prevPriceRangeMin !== priceRangeMin)))
    ) {
      this.loadFilteredProducts();
    } else if (prevRequestQueue !== requestQueue && requestQueue === 0) {
      this.loadFilteredProducts(true);
    }
  }

  componentWillUnmount() {
    const { setScrollCache } = this.props;
    const { scrollCache } = this.state;
    setScrollCache({ key: PAGE, value: scrollCache });
    // Clear on-scroll
    window.onscroll = null;
  }

  scrollChange = e => {
    // Likely not needed, keep as fail-safe for now
    if (!(e && e.target && e.target.scrollingElement && e.target.scrollingElement.scrollTop)) return;

    // Cache current gridwall scroll location
    this.setState({ scrollCache: e.target.scrollingElement.scrollTop });
  };

  setPreviousScrollLocation = () => {
    const { prevScroll, products } = this.props;

    // If previous scroll cached, and products exist
    if (prevScroll && products.length > 0) {
      // Scroll to previous position
      window.scroll(0, prevScroll);
    }
  };

  setDeptFacets = deptFacets => this.setState({ deptFacets });

  setProductList = (sortedProducts, after = null) =>
    this.setState(state => {
      const newState = { sortedProducts };
      if (state.isProductSearch) {
        newState.isProductSearch = false;
      }
      return newState;
    }, after);

  setSearchInput = searchInput => this.setState({ searchInput, isProductSearch: true });

  setSearchError = errorMsg => this.setState({ searchError: errorMsg });

  setWholesalePrice = wholesalePrice => this.setState({ wholesalePrice, newFilter: true });

  setDefaultAndWholesalePrice = price => this.setState({ defaultPrice: price, wholesalePrice: price, newFilter: true });

  incrementRequestQueue = () => {
    this.setState(state => ({
      requestQueue: state.requestQueue + 1
    }));
  };

  handleSetSearchTerm = input => {
    let key;
    const { searchTerm, setSearchTerm } = this.props;
    const adjustedInput = formatSearchInput(input);

    if (adjustedInput.length < 3) {
      this.setSearchError(adjustedInput.length === 0 ? false : { id: 'gridwall.search.error.tooFewCharacters' });
      return setSearchTerm({});
    }
    if (adjustedInput.includes(',') && adjustedInput.split(',').length > PRODUCT_SEARCH_MAX) {
      this.setSearchError({ id: 'gridwall.search.error.tooManyProducts', values: { amount: PRODUCT_SEARCH_MAX } });
      return setSearchTerm({});
    }

    this.setSearchError(false);
    if (containsProductCode(adjustedInput)) {
      key = 'productCode';
    } else if (containsStyleNumber(adjustedInput)) {
      key = 'styleNumbers';
    } else if (isColorCode(adjustedInput)) {
      key = 'colorCode';
    } else {
      key = 'productName';
    }
    if (input !== searchTerm[key]) this.loadFilteredProducts();

    return setSearchTerm({ [key]: adjustedInput });
  };

  handleSearchOnSubmit = e => {
    const { searchInput } = this.state;
    this.setState({ savedSearchKey: searchInput });

    if (e.key === 'Enter') {
      this.handleSetSearchTerm(searchInput);

      if (searchInput.length > 0) {
        sendEventToGA(GA_EVENT_SEARCH_TERM, {
          searchTerm: searchInput
        });
      }
    }
  };

  handleSearchOnFocus = () => {
    const { searchInput, savedSearchKey } = this.state;
    this.handleSetSearchTerm(searchInput);

    if (searchInput.length > 0 && savedSearchKey !== searchInput) {
      sendEventToGA(GA_EVENT_SEARCH_TERM, {
        searchTerm: searchInput
      });
    }
  };

  toggleSearch = () => this.setState(state => ({ showSearch: !state.showSearch }));

  clearSearch = () => {
    const { setSearchTerm } = this.props;
    this.setState({ searchInput: '' }, () => this.handleSearchOnFocus());

    setSearchTerm({});
    this.loadFilteredProducts();
  };

  handleMobileClearSearch = () => {
    this.toggleSearch();
    this.clearSearch();
  };

  handleListSort = async ({ value, desc }) => {
    const { sortBy, setSortBy } = this.props;
    const isDesc = desc ? 'DESC' : 'ASC';
    const updatedSort = { field: value, order: isDesc };

    if (sortBy !== updatedSort) {
      await setSortBy({ ...updatedSort, page: PAGE });
      this.loadFilteredProducts();
    }
  };

  fetchProducts = isFiltered => {
    const {
      account,
      accountDetails,
      after,
      allSizesAvailable,
      includeUnavailableProduct,
      priceRangeMax,
      priceRangeMin,
      priceRangeSet,
      requestProducts,
      searchTerm,
      selectedDepartment,
      selectedFacets,
      selectedFilters,
      sortBy,
      user
    } = this.props;
    const { newFilter } = this.state;
    const currSupportedLanguages = regionToLanguageMap.get(accountDetails.region);
    const currLanguage = currSupportedLanguages.filter(reg => reg === user.locale.split('_')[0].toUpperCase());

    requestProducts({
      accountNumber: account.number,
      after: newFilter ? null : after,
      allSizesAvailable,
      colorCode: searchTerm.colorCode,
      count: searchTerm.productName ? GRIDWALL_PRODUCT_SEARCH_LOAD_QTY : GRIDWALL_PRODUCT_LOAD_QTY,
      deptNumber: selectedDepartment.number,
      includeUnavailableProduct: includeUnavailableProduct && selectedDepartment.type === ORDER_TYPE_ATONCE,
      language: currLanguage.length > 0 ? currLanguage[0] : currSupportedLanguages[0],
      orderType: selectedDepartment.type,
      pricelistType: accountDetails.pricelistType,
      productCode: searchTerm.productCode,
      productName: searchTerm.productName,
      region: accountDetails.region,
      selectedFacets: selectedFacets,
      selectedFilters,
      sizeLocale: user.defaultSizeChart || getDefaultSizeConversion(user.country),
      sortDirection: sortBy ? sortBy.order : null,
      sortField: sortBy ? sortBy.field : null,
      styleNumbers: searchTerm.styleNumbers,
      wholesaleMax: priceRangeSet ? priceRangeMax : GRIDWALL_MAX_PRICE,
      wholesaleMin: priceRangeSet ? priceRangeMin : GRIDWALL_MIN_PRICE,
      isFiltered
      // eslint-disable-next-line consistent-return
    }).then(results => {
      const {
        payload: { cursor, facets, styles, aggregations }
      } = results;

      this.setState(state => (facets && !state.deptFacets ? { deptFacets: facets } : {}));

      if (styles) {
        const { products, unitAllotments } = this.props;
        const productsWithOptions = products.map(style => ({
          ...style,
          products: style.products.map(prod => ({
            ...prod,
            hasPurchaseOptions: hasAllotmentsOrOptions(selectedDepartment.purchaseOptions || [], prod),
            hasUnitAllotments: hasAllotmentsOrOptions(unitAllotments || [], prod)
          }))
        }));
        this.setProductList(productsWithOptions);
      }

      this.setState({
        hasMore: cursor !== undefined && cursor !== null,
        requestQueue: 0
      });

      if (aggregations && aggregations.length > 0 && aggregations[0] && aggregations[0].value) {
        if (!priceRangeSet) {
          return this.setDefaultAndWholesalePrice([
            Math.floor(aggregations[0].value / 10) * 10,
            Math.ceil(aggregations[1].value / 10) * 10
          ]);
        }
      }
    });
  };

  loadProducts = async () => {
    const { isFetching, productCount } = this.props;
    const { hasMore } = this.state;

    if (!isFetching && hasMore && productCount > GRIDWALL_PRODUCT_LOAD_QTY) {
      this.setState({ newFilter: false }, () => this.fetchProducts(false));
    } else if (productCount < GRIDWALL_PRODUCT_LOAD_QTY) {
      this.setState({ hasMore: false });
    }
  };

  loadFilteredProducts = (isLastInQueue = false) => {
    const { clearProducts, isFetching } = this.props;
    const { requestQueue } = this.state;

    if (!isLastInQueue && isFetching) {
      this.setState({ newFilter: true });
      this.incrementRequestQueue();
    } else if (requestQueue === 0) {
      clearProducts();

      this.setState({ sortedProducts: [] }, () => {
        const { isFetching } = this.props;
        if (isFetching) this.incrementRequestQueue();
        else {
          this.fetchProducts(true);
        }
      });
    }
  };

  handleFilterClick = e => {
    if (e) {
      e.preventDefault();
    }
    this.setState(state => ({ isFilterOpen: !state.isFilterOpen }));
  };

  handlePriceReset = () => {
    const { addPriceRange, togglePriceRangeSet } = this.props;
    const { defaultPrice } = this.state;
    togglePriceRangeSet(false);
    this.setWholesalePrice(defaultPrice);

    addPriceRange(defaultPrice);
    this.loadFilteredProducts();
  };

  handleProductClick = productId => {
    const {
      match: { params },
      products,
      history,
      selectedDepartment,
      selectProduct,
      includeUnavailableProduct
    } = this.props;
    // A style number can be split across multiple gridwall cards (grouped by promo indicator, etc.),
    // so select the card that actually contains the clicked product.
    const style = findStyleForProduct(products, productId);
    selectProduct(style);

    if (selectedDepartment) {
      let url = `/shop/${params.accountId}/dept/${selectedDepartment.number}/${selectedDepartment.type}/${productId}`;
      if (includeUnavailableProduct) {
        url += '?inclUnavail=1';
      }
      history.push(url);
    }
  };

  handleSelectedFilterRemoval = filter => {
    const { removeSelectedFilter } = this.props;
    removeSelectedFilter(filter);
    this.loadFilteredProducts();
  };

  formatFilters = () => {
    const { selectedFilters } = this.props;

    return Object.entries(selectedFilters).reduce((acc, [key, values]) => {
      values.forEach(value => acc.push({ key, value }));
      return acc;
    }, []);
  };

  formatFacets = () => {
    const { selectedFacets } = this.props;
    return Object.entries(selectedFacets).sort((division, gender) => gender - division);
  };

  handleSelectedFacetRemoval = facet => {
    const { clearSelectedFacet } = this.props;
    clearSelectedFacet(facet);
    this.loadFilteredProducts();
  };

  handleRemoveUnavailableProduct = () => {
    const { setIncludeUnavailableProduct } = this.props;
    setIncludeUnavailableProduct(false);
    this.loadFilteredProducts();
  };

  render() {
    const {
      filterCount,
      history,
      includeUnavailableProduct,
      isFetching,
      isGreaterChinaSalesOrg,
      priceRangeMax,
      priceRangeMin,
      priceRangeSet,
      productCount,
      searchTerm,
      selectedDepartment,
      selectedFilters,
      selectedFacets
    } = this.props;
    const {
      defaultPrice,
      hasMore,
      isFilterOpen,
      searchError,
      searchInput,
      showSearch,
      sortedProducts,
      wholesalePrice,
      deptFacets
    } = this.state;
    if (!selectedDepartment || !selectedDepartment.type) {
      history.push(DEPT_SELECT_URL);
    }
    const filterKeys = Object.keys(selectedFilters);
    const filterKeysList = filterKeys.length > 0 ? filterKeys.join(',') : '';

    const { gender, division } = selectedFacets;
    const normalizedGender = gender && productDivisionMap.get(gender);
    const normalizedDivision = division && productDivisionMap.get(division);

    const gaTitle =
      normalizedGender || normalizedDivision
        ? `${normalizedGender || ''} ${normalizedDivision || ''} ${
            filterKeysList.length > 0 ? `- ${filterKeysList}` : ''
          }`
        : `All Products ${filterKeysList.length > 0 ? `- ${filterKeysList}` : ''}`;

    const genderDivision =
      !gender && !division ? (
        <TranslatedCopy id='gridwall.header.title' />
      ) : (
        <ProductGenderDivision gender={gender} division={division} filterKeysList={filterKeysList} isHeader />
      );

    return (
      <div className='gridwall'>
        {selectedDepartment && (
          <>
            {gaTitle.length > 0 && <PageTitle title={gaTitle} />}
            <GridwallFilters
              clearSearch={this.clearSearch}
              defaultPrice={defaultPrice}
              handleFilterClick={this.handleFilterClick}
              handlePriceReset={this.handlePriceReset}
              isFilterOpen={isFilterOpen}
              isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
              loadFilteredProducts={this.loadFilteredProducts}
              sortedProducts={sortedProducts}
              setWholesalePrice={this.setWholesalePrice}
              wholesalePrice={wholesalePrice}
              deptFacets={deptFacets}
              isFetching={isFetching}
            />
            <div className={classnames('gridwall__main', { showSearch: showSearch })}>
              <PageHeader
                page='gridWall'
                title={
                  <div
                    className={classnames(
                      'gridwall__main_header-content',
                      'flex-container row start align-center',
                      'pl4-sm pr2-sm u-full-width'
                    )}
                    data-desc='gridwall__main_header_selected_catalog'
                  >
                    <div>
                      <div className='d-sm-b d-md-h body-4'>
                        {selectedDepartment && selectedDepartment.name ? selectedDepartment.name : genderDivision}
                      </div>
                      {genderDivision}
                    </div>
                    <span
                      className='body-4 text-lowercase text-color-secondary ml6-sm gridwall__product_count d-sm-h d-md-ib'
                      data-desc='gridwall__product_count'
                    >
                      <TranslatedCopy
                        id='gridwall.header.items'
                        values={{ amount: productCount || (sortedProducts && sortedProducts.length) || '0' }}
                      />
                    </span>
                  </div>
                }
                className='flex-container row wrap bg-white'
                back={
                  <Link to='/' className='d-sm-h d-ib-md'>
                    <Icon name='chevron-left' alt='go back' className='page-title-back' />
                  </Link>
                }
              >
                <div className='d-sm-h d-lg-ib'>
                  <QuickAdd />
                </div>
                <div className='d-sm-h d-lg-ib'>
                  <div className='flex-container row align-center'>
                    <InputContainer
                      label={new TranslatedCopy({ id: 'global.search' }).toString()}
                      isSearch
                      value={searchTerm}
                      clear={this.clearSearch}
                      extraClassName='search-input'
                      dataDesc='gridwall__search'
                      error={searchError && new TranslatedCopy(searchError).toString()}
                    >
                      <TextInput
                        type='text'
                        autoComplete='off'
                        name='gridwall__search'
                        onChange={this.setSearchInput}
                        onKeyPress={this.handleSearchOnSubmit}
                        onBlur={this.handleSearchOnFocus}
                        value={searchInput}
                      />
                    </InputContainer>
                    <GlobalToolTip className='tooltip mb2-sm' content={<GridwallSearchToolTip />} />
                  </div>
                </div>

                <div className='d-sm-ib d-lg-h u-full-width'>
                  {showSearch ? (
                    <div className='flex-container row align-center'>
                      <InputContainer
                        label={new TranslatedCopy({ id: 'global.search' }).toString()}
                        isSearch
                        value={searchTerm}
                        clear={this.handleMobileClearSearch}
                        extraClassName='search-input u-full-width'
                        dataDesc='gridwall__search'
                        error={searchError && new TranslatedCopy(searchError).toString()}
                      >
                        <TextInput
                          type='text'
                          autoComplete='off'
                          name='gridwall__search'
                          onChange={this.setSearchInput}
                          onKeyPress={this.handleSearchOnSubmit}
                          onBlur={this.handleSearchOnFocus}
                          value={searchInput}
                        />
                      </InputContainer>
                      <GlobalToolTip className='tooltip mb2-sm' content={<GridwallSearchToolTip />} />
                    </div>
                  ) : (
                    <Button useBareClass textLink onClick={this.toggleSearch}>
                      <Icon
                        name='search'
                        alt={new TranslatedCopy({ id: 'global.search' }).toString()}
                        className='va-sm-m'
                      />
                    </Button>
                  )}
                </div>
              </PageHeader>
              <div
                className={classnames(
                  'gridwall__main_header',
                  'flex-container row wrap start bg-secondary-grey p4-sm pr0-md'
                )}
              >
                <Button className='d-sm-b d-lg-h body-2 u-bold mr4-sm mb4-sm' onClick={this.handleFilterClick}>
                  {filterCount ? (
                    <TranslatedCopy id='gridwall.filters.count' values={{ count: filterCount }} />
                  ) : (
                    <TranslatedCopy id='global.filters' />
                  )}
                </Button>

                {this.formatFacets(selectedFacets)
                  .map(facet => (
                    // pill tags for facets
                    <FilterTag
                      onClick={() => this.handleSelectedFacetRemoval(facet[0])}
                      data-desc={`gridwall__filter_tag_${facet[1].toLowerCase()}`}
                      key={facet[1]}
                    >
                      {facet[1] === 'EQMT' ? 'Equipment & Accessories' : productDivisionMap.get(facet[1])}
                    </FilterTag>
                  ))
                  .sort((division, gender) => gender - division)}

                {this.formatFilters(selectedFilters).map(filter => (
                  // pill tags for filters
                  <FilterTag
                    onClick={() => this.handleSelectedFilterRemoval(filter)}
                    data-desc={`gridwall__filter_tag_${filter.value.toLowerCase()}`}
                    key={filter.value}
                  >
                    {filter.value.toLowerCase()}
                  </FilterTag>
                ))}
                {priceRangeSet && (
                  <FilterTag
                    onClick={this.handlePriceReset}
                    data-desc='gridwall__filter_tag_price_range'
                    key='priceRange'
                  >
                    <Currency value={priceRangeMin.toString()} type={selectedDepartment.code} />
                    {' - '}
                    <Currency value={priceRangeMax.toString()} type={selectedDepartment.code} />
                  </FilterTag>
                )}
                {includeUnavailableProduct && (
                  <FilterTag
                    onClick={this.handleRemoveUnavailableProduct}
                    data-desc='gridwall__filter_tag_include_unavailable'
                    key='includeUnavailable'
                  >
                    <TranslatedCopy id='gridwall.filters.availability.includesUnavailable' />
                  </FilterTag>
                )}
                {false && (
                  <SortOptions
                    sortBy={[
                      {
                        value: 'prices.wholesale',
                        name: 'global.sort.price'
                      }
                    ]}
                    handleExternalSort={this.handleListSort}
                  />
                )}
              </div>

              {sortedProducts.length > 0 ? (
                <GridwallProducts
                  products={sortedProducts}
                  loadProducts={this.loadProducts}
                  handleProductClick={this.handleProductClick}
                  hasMore={hasMore}
                />
              ) : (
                <div className='gridwall__main_empty u-full-width body-4 text-color-secondary'>
                  {isFetching || !deptFacets ? (
                    <LoadingMessage title={new TranslatedCopy({ id: 'global.results' }).toString()} />
                  ) : (
                    <NoResults titleId='gridwall.search.noResults' />
                  )}
                </div>
              )}
            </div>
          </>
        )}
        <BackToTop />
      </div>
    );
  }
}

Gridwall.propTypes = {
  account: userAccountTypes,
  accountDetails: PropTypes.object.isRequired,
  addPriceRange: PropTypes.func.isRequired,
  after: PropTypes.string,
  allSizesAvailable: PropTypes.string,
  clearProducts: PropTypes.func.isRequired,
  clearSelectedFacet: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
  clearSelectedFiltersMinusCatalogs: PropTypes.func.isRequired,
  facets: PropTypes.array,
  filterCount: PropTypes.number,
  history: ReactRouterPropTypes.history.isRequired,
  includeUnavailableProduct: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  priceRangeMax: PropTypes.number.isRequired,
  priceRangeMin: PropTypes.number.isRequired,
  priceRangeSet: PropTypes.bool.isRequired,
  productCount: PropTypes.number.isRequired,
  products: PropTypes.arrayOf(productTypes),
  removeSelectedFilter: PropTypes.func.isRequired,
  requestProducts: PropTypes.func.isRequired,
  searchTerm: PropTypes.object.isRequired,
  selectedDepartment: selectedDepartmentTypes,
  selectedFacets: PropTypes.object.isRequired,
  selectedFilters: PropTypes.any.isRequired,
  selectProduct: PropTypes.func.isRequired,
  setIncludeUnavailableProduct: PropTypes.func.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  setSortBy: PropTypes.func.isRequired,
  sortBy: sortByTypes.isRequired,
  togglePriceRangeSet: PropTypes.func.isRequired,
  user: userTypes,
  match: PropTypes.any,
  setScrollCache: PropTypes.func.isRequired,
  prevScroll: PropTypes.number.isRequired,
  unitAllotments: PropTypes.array.isRequired
};

Gridwall.defaultProps = {
  account: null,
  after: null,
  allSizesAvailable: false,
  facets: null,
  filterCount: null,
  products: null,
  selectedDepartment: null,
  user: null,
  match: null
};

const mapStateToProps = state => ({
  account: getUserAccount(state),
  accountDetails: accountDetails(state),
  activeSubTypeFacets: getActiveSubTypeFacets(state),
  after: getCursorValue(state),
  allSubTypeFacets: getAllSubTypeFacets(state),
  facets: getFacets(state),
  filterCount: filterCount(state),
  filters: getFilters(state),
  isFetching: getIsFetching(state),
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state),
  priceRangeMax: priceRangeMax(state),
  priceRangeMin: priceRangeMin(state),
  priceRangeSet: priceRangeSet(state),
  productCount: getProductCount(state),
  products: getShopProducts(state),
  searchTerm: searchTerm(state),
  selectedDepartment: getSelectedDepartment(state),
  selectedFacets: getSelectedFacets(state),
  selectedFilters: getSelectedFilters(state),
  sortBy: sortBy(state),
  user: getUserData(state),
  prevScroll: getScrollCache(state, PAGE),
  unitAllotments: getAllotmentsForSelectedDepartment(state).unitAllotments || [],
  allSizesAvailable: selectAllSizesAvailable(state),
  includeUnavailableProduct: selectIncludeUnavailableProduct(state)
});

const connector = connect(mapStateToProps, {
  addPriceRange,
  clearProducts,
  clearSelectedFacet,
  clearSelectedFilters,
  clearSelectedFiltersMinusCatalogs,
  removeSelectedFilter,
  requestProducts,
  resetCursor,
  selectProduct,
  setSearchTerm,
  setSortBy,
  togglePriceRangeSet,
  setScrollCache,
  setAllSizesAvailable,
  setIncludeUnavailableProduct
});

export default connector(Gridwall);
